import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@hooks/useRedux';

/**
 * Guard de route : redirige vers /auth/login si non authentifié.
 */
export function RequireAuth() {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    console.log('Not authenticated');
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
